import { Spinner } from "@trustpilot/businessapp-patternlibrary";
import React from "react";

import { Remote } from "../../remotes";
import { Analytics, BaseDataResponseBody, ShellConnect } from "../../types";
import { RemoteComponent } from "../../utils/mf-dynamic-remote-component";
import { Container } from "./shared";

export interface RemoteHostComponentTypes {
  config: Omit<Remote, "url">;
  customProps: BaseDataResponseBody & {
    localeLocalizationProviderOverride: string;
    shellConnect: ShellConnect;
    analytics: Analytics;
  };
}

const RemoteHostComponent: React.FC<RemoteHostComponentTypes> = ({ config, customProps }) => {
  const Component = React.lazy(() => RemoteComponent(config, customProps.businessUser.id));

  return (
    <React.Suspense
      fallback={
        <Container>
          <Spinner size={36} />
        </Container>
      }
    >
      <Component config={config} {...customProps} />
    </React.Suspense>
  );
};

export default RemoteHostComponent;
